import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, Radio} from '@material-ui/core';
import CustomTypo from '../../components/CustomTypo';
import { calculateDistanceTimeFrEpoch } from '../../utils/util';
import renderHTML from 'react-render-html';
import {DeleteWhiteIcon, RadioCheckedWhiteIcon, RadioWhiteIcon, DeleteIcon, RadioIcon} from '../../components/icons'
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import InfiniteScroll from 'react-infinite-scroll-component';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
const styles = theme => ({
    container:{
        padding: theme.spacing(6,4,4,4)
    },
    boxItemPre:{
       // padding: theme.spacing(0,2,0,0)
    },
    boxItemContent: {
        padding: theme.spacing(2,4,2,4),
        marginTop: theme.spacing(2),
        //marginBottom: theme.spacing(1.5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer'
    },
    notification_read: {
        width: theme.spacing(2),
        height: theme.spacing(2),
        borderRadius: theme.spacing(3),
        backgroundColor: theme.palette.button.category.backgroundColor,
        shadowColor: theme.palette.background.primary,
        shadowOffset: { width: 2, height: 2 },
        shadowOpacity: 1,
        shadowRadius: 4,
        elevation: 5,
        alignSelf: 'center',
        marginLeft: theme.spacing(1)
    },
    bg_icon:{
        width: theme.spacing(6),
        height: theme.spacing(6),
        borderRadius: theme.spacing(6),
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        backgroundColor: theme.palette.icon.trash,
        cursor: "pointer",
        touchAction: "manipulation",
    },
    content: {
        padding: theme.spacing(1),
        whiteSpace: 'pre-line',
    },
    wraptext: {
        lineHeight:'1.25em',
        // height:'2em',
        overflow: "hidden",
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 4,
        '-webkit-box-orient': 'vertical'
    },
    radio:{
        cursor: 'pointer'
    }
});
function NotificationsView(props) {
    const [isEdit, setIsEdit] = useState(false);

    const onEditNotifications = () =>{
        if(isEdit){
            props.clearRemoveItem();
        }
        setIsEdit(!isEdit);
    }
    const onDeleteMultiNotification = async() =>{
        var result = await props.onDeleteMultiNotification();
        setIsEdit(result ? false : true);
    }

    const {classes, t , notifications, open, onClose, handleLoadMore, onShowDetail, showLoading, hasMore,showLoadMore, removeItems} = props
    //console.log('removeItems===',removeItems)
    return (
            <DrawerCustom open={open} onClose={onClose} title={t('notifications')}
                enableBack={{icon:<DeleteWhiteIcon/>, action: isEdit?onDeleteMultiNotification:onEditNotifications, active:!isEdit||props.removeItems.length>0}}
                children={       
                    <Grid xs={12} item>
                        {/* <Grid xs={12} item>
                            <CustomTypo variant='h3' color='onPrimary'>{t('notifications')}</CustomTypo>
                        </Grid> */}
                            <Grid xs={12} item container justify='center' >
                                {showLoading?<CustomizedCircularProgress/>:null}
                            </Grid> 
                            <Grid xs={12} item>
                                <InfiniteScroll
                                    dataLength={notifications.length} //This is important field to render the next data
                                    next={handleLoadMore}
                                    hasMore={hasMore}
                                    height={window.innerHeight}
                                    loader={showLoadMore? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                                    >
                                    <Grid xs={12} item container className={classes.margin}>
                                        {notifications.map((item,index)=><NotificationItem 
                                            key={index} item ={item} 
                                            onShowDetail={onShowDetail} 
                                            onDeleleNotification={props.onDeleleNotification} 
                                            classes={classes}
                                            isEdit={isEdit}
                                            addItemToRemove={props.addItemToRemove} 
                                            removeItems={props.removeItems}/>)}
                                    </Grid>
                                </InfiniteScroll>
                            </Grid>
                
                    </Grid>
                    }
            />
    );
}

function NotificationItem(props) {
    var item = props.item;
    var removeItems = props.removeItems;
    var itemExist = removeItems.filter(i => {
        return i.id == item.id
    })
    
    //console.log('itemExist===',itemExist)
    const {classes} = props;
    return (
            <Grid item container>
                <Grid xs={11} item className={classes.boxItemPre}>
                    <Grid item container className={classes.boxItemContent} onClick={() => props.onShowDetail(item)}>
                        <Grid xs={12} sm={12} item container alignItems='center'>
                            {item&&<CustomTypo variant={!item.is_viewed?'subtitle2':'body2'} color='primary'>{item.subject ? item.subject : ""}</CustomTypo>}
                            {item&&!item.is_viewed && <Grid className={classes.notification_read} />}
                        </Grid>
                        <Grid xs={12} sm={12} item container alignItems='center'>
                            <CustomTypo variant='body2' color='primary'>
                                {item&&item.created_on ? calculateDistanceTimeFrEpoch(item.created_on) : ""}
                            </CustomTypo>
                                {/* <IconButton onClick={()=>props.onDeleleNotification(item.id)}><DeleteIcon/></IconButton> */}
                        </Grid>
                        {/* <Grid xs={12} item className={classes.content}>
                            {item?<CustomTypo variant='body2' color='primary' className={classes.wraptext}>{item.content ? renderHTML(item.content) : ""}</CustomTypo>:null}
                        </Grid> */}
                    </Grid>
                </Grid>
                <Grid xs={1} item container justify='flex-end' alignItems='center'>
                {props.isEdit? <Grid item className={classes.radio} onClick={() => props.addItemToRemove(item)}>
                    {itemExist && itemExist.length > 0 ? <RadioCheckedWhiteIcon/> : <RadioIcon/>}
                </Grid>:
                    <Grid item className={classes.bg_icon} onClick={() => props.onDeleleNotification(item.id)}>
                        <DeleteWhiteIcon />
                    </Grid>}
                </Grid>
            </Grid>
        )
}
export default withStyles(styles)(withTranslation()(NotificationsView));